/* eslint-disable react/prop-types */
// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';

class ItemFiatV2 extends Component {
  getLink() {
    const { part_link, slug } = this.props;
    return `${part_link}/${slug}`;
  }

  render() {
    const { image, title, width, height, customClasses, abarthScorpionIcon } =
      this.props;

    return (
      <div>
        <a href={this.getLink()}>
          <div className="new-vehicle-card__background" />
          <h3 className="new-vehicle-card__title">{title}</h3>
          {title.toLowerCase().includes('abarth') && (
            <img
              src={abarthScorpionIcon}
              className="new-vehicle-card__icon-abarth"
              alt="Selo do Abarth"
              width="45"
              height="50"
            />
          )}
          <img
            className={`new-vehicle-card__img ${customClasses}`}
            src={image}
            alt={`Imagem do ${title}`}
            width={width}
            height={height}
          />
        </a>
        <div
          className="new-vehicle-card__footer"
          aria-label={`Saiba Mais sobre o ${title}`}
        >
          <a
            href={this.getLink()}
            className="btn button button--link card__cta"
          >
            <i className="icon icon-chevron-down" />
            <span>Saiba Mais</span>
          </a>
        </div>
      </div>
    );
  }
}

export default ItemFiatV2;
